<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section E-Payment Transaction History
        .row.pad_t--30.align-items-center
          .col-lg-4
            b-form-select(v-model="filter.status", :options="enums.statuses", :disabled="!hasPayments")

          .col-lg-4.pad_t--10-md
            b-form-select(v-model="filter.month", :options="enums.months", :disabled="!hasPayments")

          .col-lg-4.pad_t--10-md.align__right-md(v-if="canRemoveFilter")
            button.button.button-neutral(@click="CLEAR_FILTER") Clear Filter

        .mar_t--25
          Loading(:isLoading="isDataLoading", type="bar")
            .shown_lg
              table.newtable.break-lg(v-if="hasPayments")
                tbody
                  tr(v-for="r in paymentsCleaned") 
                    td(data-label="Date submitted"): span {{ r.time | formatDateTime }}
                    td(data-label="Amount Paid"): span RM {{ r.amount | money }}
                    td(data-label="Client Code"): span {{ r.clientCode }}
                    td(data-label="Payment Status"): span
                      .statusPositive(v-if="r.statusCode === 0") 
                        span.statusIcon: font-awesome-icon(icon="check")
                        | {{ r.statusText }}
                      .statusNegative(v-else-if="r.statusCode === 2 || r.statusCode === 3 || r.statusCode === 4") 
                        span.statusIcon: font-awesome-icon(icon="times")
                        | {{ r.statusText }}
                      .statusPending(v-else-if="r.statusCode === 1 || r.statusCode === 5 || r.statusCode === 6") 
                        span.statusIcon: font-awesome-icon(icon="spinner")
                        | {{ r.statusText }}
                      .statusNeutral(v-else)
                        | {{ r.statusText }}
                    td(data-label="Remark"): span
                      .statusPositive(v-if="r.statusCode === 0") 
                        | {{ r.statusDescription }}
                      .statusNegative(v-else-if="r.statusCode === 2 || r.statusCode === 3 || r.statusCode === 4") 
                        | {{ r.statusDescription }}
                      .statusPending(v-else-if="r.statusCode === 1 || r.statusCode === 5 || r.statusCode === 6") 
                        | {{ r.statusDescription }}
                      .statusNeutral(v-else)
                        | {{ r.statusDescription }}
                    td(data-label="Payer Name"): span {{ r.payerName }}
                    td(data-label="Bank Code"): span {{ r.bankCode }}

              MessageBar(v-if="!hasPayments", type="warning")
                | No records found, you have yet to make an E-Payment via FPX. &nbsp;
                router-link(to="/payment/ePayment") Make your first FPX E-Payment!

              MessageBar(v-if="hasPayments && paymentsCleaned.length === 0", type="warning")
                | No records found, please change the search query.

            .hidden_lg
              template(v-if="hasPayments")
                .pstatus--label
                  .row
                    .col-2: .pstatus--first_column Date
                    .col.align__center Amount Paid
                    .col.align__center Client Code
                    .col.align__center Payment Status
                    .col-auto: .pstatus--arrow.no_show: font-awesome-icon(icon="angle-down")

                template(v-if="paymentsCleaned.length > 0") 
                  div(v-for="(r) in paymentsCleaned") 
                    .pstatus--header(@click="OPEN_TOGGLE(r.fpxPaymentId)", :class="isOpened[r.fpxPaymentId] ? '' : 'collapsed'")
                      .row
                        .col-2: .pstatus--first_column
                          | {{ r.time | formatDate }} 
                        .col.align__center
                          | RM {{ r.amount | money }}
                        .col.align__center 
                          | {{ r.clientCode }}
                        .col.align__center
                          .statusPositive(v-if="r.statusCode === 0") 
                            span.statusIcon: font-awesome-icon(icon="check")
                            | {{ r.statusText }}
                          .statusNegative(v-else-if="r.statusCode === 2 || r.statusCode === 3 || r.statusCode === 4") 
                            span.statusIcon: font-awesome-icon(icon="times")
                            | {{ r.statusText }}
                          .statusPending(v-else-if="r.statusCode === 1 || r.statusCode === 5 || r.statusCode === 6") 
                            span.statusIcon: font-awesome-icon(icon="spinner")
                            | {{ r.statusText }}
                          .statusNeutral(v-else)
                            | {{ r.statusText }}
                        .col-auto
                          .pstatus--arrow.down: font-awesome-icon(icon="angle-down")
                          .pstatus--arrow.up: font-awesome-icon(icon="angle-up")

                    .pstatus--content(v-if="isOpened[r.fpxPaymentId]")
                      b-card
                        .pstatus--card
                          .pstatus--card-meta.text--color_grey
                            .row
                              .col-3 {{ r.time | formatDateTime }}
                              .col-9 FPX Payment ID: &nbsp; {{ r.fpxPaymentId }}
                          .row
                            .col-3
                              .pstatus--card-label Bank code
                              .pstatus--card-value {{ r.bankCode }}
                            .col-3
                              .pstatus--card-label Payer name
                              .pstatus--card-value {{ r.payerName }}
                            .col-6
                              .pstatus--card-label Payment Status Description
                              .pstatus--card-value 
                                .statusPositive(v-if="r.statusCode === 0") 
                                  | {{ r.statusDescription }}
                                .statusNegative(v-else-if="r.statusCode === 2 || r.statusCode === 3 || r.statusCode === 4") 
                                  | {{ r.statusDescription }}
                                .statusPending(v-else-if="r.statusCode === 1 || r.statusCode === 5 || r.statusCode === 6") 
                                  | {{ r.statusDescription }}
                                .statusNeutral(v-else)
                                  | {{ r.statusDescription }}
                
                template(v-else) 
                  MessageBar.mar_t--10(type="warning") No records found, please change the search query.
            
              template(v-else)
                MessageBar(type="warning") 
                  | No records found, you have yet to make an E-Payment via FPX. &nbsp;
                  router-link(to="/payment/ePayment") Make your first FPX E-Payment!

</template>



<script>
import * as moment from 'moment';

import allFilters from '@/lib/filters';
import requestHandlers from '@/mixins/requestHandlers';
import Loading from '@/components/Loading';
import MessageBar from '@/components/MessageBar';

export default {
  name: 'paymentStatus',
  mixins: [requestHandlers],
  components: {
    Loading,
    MessageBar,
  },

  data() {
    return {
      payments: [],

      filter: {
        month: null,
        status: null,
      },

      isOpened: {

      },

      enums: {
        months: [],
        statuses: [
          { text: 'Select Status', value: null },
          { text: "Successful", value: "0" },
          { text: "Pending", value: "1/5/6" },
          { text: "Unsuccessful", value: "2/3/4" },
        ],
      }
    }
  },

  computed: {
    hasPayments() {
      return this.payments.length > 0;
    },
    canRemoveFilter() {
      let _canRemove = false;

      Object.keys(this.filter).forEach(key => {
        if(this.filter[key] !== null) {
          _canRemove = true;
        }
      })

      return _canRemove;
    },

    paymentsCleaned() {
      return this.payments
      .map(item => {
        let statusSplit = item.statusMessage.split('|');
        let _obj = {
          clientCode: item.clientCode, 
          amount: item.amount,
          time: item.time,
          fpxPaymentId: item.paymentID,
          statusCode: item.clientPaymentStatus.code,
          statusText: item.clientPaymentStatus.displayName,
          statusDescription: item.clientPaymentStatus.description,
          bankCode: '-',
          payerName: '-',
        };

        // Set Bank code and payer name based on the statusMessage retrieved from FPX
        // if status is Unsuccessful (4), then display as '-'
        let statusMessageSplit = item.statusMessage.split('|');

        if(statusMessageSplit.length > 1 && _obj.statusCode !== 4) {
          _obj.bankCode = statusMessageSplit[0];
          _obj.payerName = statusMessageSplit[1];
        }

        return _obj;
      })
      .filter(payment => {
        let _passStatus = true;
        let _passMonth = true;

        if(this.filter.status) {
          let allStatusSelected = this.filter.status.split('/');
          if(!(allStatusSelected.findIndex(a => Number(a) === payment.statusCode) > -1)) {
            _passStatus = false;  
          }
        }

        if(this.filter.month && this.filter.month !== moment(payment.time).format('YYYY-MM')) {
          _passMonth = false;
        }

        return _passStatus && _passMonth;
      })
    }
  },

  methods: {
    OPEN_TOGGLE(id) {
      if(this.isOpened[id] === true) {
        this.isOpened[id] = false;
        return;
      }

      Object.keys(this.isOpened).forEach(key => {
        this.isOpened[key] = false;
      });

      this.isOpened[id] = true;
    },

    CLEAR_FILTER() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null;
      })
    },

    async FETCH_STATUSES() {
      this.REQUEST_INIT();

      try {
        let response = await this.$axios.get('Payment/History');

        if(response.status !== 200) {
          throw new Error('An error has occured.');
        }

        let { data } = response;

        if(data.payments && Array.isArray(data.payments)) {
          data.payments.forEach(item => {
            this.$set(this.isOpened, item.paymentID, false);
          });

          this.payments = data.payments;
        }

      } catch(error) {
        this.HANDLE_ERROR_GENERIC(error);

      } finally {
        this.REQUEST_FINALLY();
      }
    },

    GENERATE_MONTH_OPTIONS() {
      let _months = [];

      let currentDate = moment().startOf('day');
      let startDate = moment().subtract(6, 'months').startOf('month');

      while(startDate.add(1, 'months').diff(currentDate) < 0) {
        let _startDate = startDate.clone();

        let _obj = {
          text: _startDate.format('MMMM YYYY'),
          value: _startDate.format('YYYY-MM'),
        }

        _months.push(_obj);
      }

      _months.push({ text: 'Select Month', value: null });

      this.enums.months = _months.reverse();
    },
  },

  created() {
    this.FETCH_STATUSES();
    this.GENERATE_MONTH_OPTIONS();
  },

  filters: {
    money: allFilters.twoDecimal,
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    formatDateTime(date) {
      return moment(date).format('h:mma, D MMM YYYY');
    },
  },
}
</script>




<style lang="scss">

</style>
